export default "__VITE_ASSET__DSUufxmJ__"